<template>
  <div class="tugas">
    <div class="header">
      <h3>Profil</h3>
    </div>

    <div class="body">
      <form>
        <div class="form-group">
          <label for="">Nama</label>
          <input type="text" v-model="$user.nama" readonly />
        </div>
        <div class="form-group">
          <label for="">Divisi</label>
          <input type="text" v-model="$user.divisi" readonly />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import * as api from "../api/Api";

import Loading from "./icons/Loading";
import Back from "./icons/Back.vue";

export default {
  name: "Task",
  components: {
    Back,
    Loading,
  },
  data() {
    return {
      param: {
        id_user: null,
        catatan: null,
      },
      loading: false,
    };
  },
  methods: {
    moment,
    simpan() {
      if (!this.param.id_user) {
        alert("Pilih PIC");
        return;
      }

      if (!this.param.catatan) {
        alert("Input catatan");
        return;
      }

      this.loading = true;
      api
        .post("/v1/kendali_kerja/NotulenController/save", this.param)
        .then((r) => {
          this.loading = false;
          this.$router.back();
        });
    },
    hapus() {
      if (confirm("Hapus notulen?")) {
        api
          .post("/v1/kendali_kerja/NotulenController/delete", this.param)
          .then((r) => {
            this.$router.back();
          });
      }
    },
    load(id) {
      api.get("/v1/kendali_kerja/NotulenController/get?id=" + id).then((r) => {
        this.param = r.data;
      });
    },
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.load(this.$route.params.id);
    }
  },
};
</script>

<style scoped lang="scss">
.tugas {
  padding: 20px;

  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    left: calc(50% - 240px);
    width: 440px;
    display: flex;
    gap: 10px;
    align-items: center;
    border-bottom: 1px solid #ccc;
    padding: 15px 20px;
    background: #fff;

    @media screen and (max-width: 768px) {
      left: 0;
      width: calc(100% - 40px);
    }

    h3 {
      margin: 0;
    }
    .icon {
      height: 26px;
      display: flex;
      align-items: center;
    }
  }

  .body {
    padding-top: 60px;
    padding-bottom: 100px;
  }

  .btn-group {
    display: flex;
    gap: 10px;
    .btn-hapus {
      background: none;
      border: 1px solid #f00;
      color: #f00;
      &:active {
        background: #eee;
      }
    }
  }

  .profil {
    text-align: center;
  }

  .file {
    position: relative;
    text-align: center;
    font-size: 14px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    padding: 15px;
    border-radius: 6px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Profil.vue